import coreLibrary from "../../../helpers/CoreLibrary";

export const TabMixin = {
    extends: coreLibrary,
    props: {
        tabs: {
            type: Array,
            require: true
        },
        tabdate: {
            type: Object,
            require: true
        }
    },
    data() {
        return {
            preLoader: true,
            queryStringKey: 'tab',
            queryStringValue: '',
            currentIndex: 0,
            componentName: '',
            componentId: '',
            componentProps: '',
            componentTitle: '',
            componentButton: {},
            chart:[],
            allData: [],
        }
    },
    computed: {
        filteredTab() {
            return this.tabs.filter((tab) => {
                if (!this.isUndefined(tab.permission)) {
                    if (tab.permission === false) {
                        return false
                    } else return true;
                }
                return true;
            });
        }
    },
    mounted() {
        this.queryStringValue = this.getQueryStringValue(this.queryStringKey);
        this.setTabByName();
    },
    methods: {
        priceFormated(price) {
            return parseFloat(price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(',', '.');
          },
        setQueryString(name) {
            const pageTitle = window.document.title;
            window.history.pushState("", pageTitle, `?${this.queryStringKey}=${name}`);
        },

        getChart(set) {
            this.preLoader = true;
            this.axiosGet('/crm/reportallgantt?type='+set.type+'&year='+this.tabdate.year+'&month='+this.tabdate.month)
                .then((res) => {
                    this.chart = res.data;
                })
                .finally(() => {
                    this.allData = this.chart.set[0].data.map((value, index) => {
                        return {
                          id: index + 1,
                          name: this.chart.labels[index],
                          color: this.chart.set[0].backgroundColor[index],
                          value: value
                        };
                      });

                    this.preLoader = false;
                });
        },

        setTabByName() {
            let currentTab = {},
                result = {};
            result = this.filteredTab.find((item, index) => {
                if (item.name == this.queryStringValue) {
                    this.currentIndex = index;
                    return item;
                }
            });

            currentTab = result ? result : this.filteredTab[this.currentIndex];

            this.loadComponent(currentTab, this.currentIndex);
        },

        loadComponent(tab, index) {
            this.currentIndex = index;
            this.componentTitle = tab.title;
            this.componentId = tab.name + '-' + index;
            this.componentName = tab.component;
            this.componentProps = tab.props;
            this.getChart(tab.props);
            if (!this.isUndefined(tab.headerButton)) {
                this.componentButton = tab.headerButton;
            } else this.componentButton = {};

            this.setQueryString(tab.name);

           
        }
    }
};
